import { useContext, useEffect, useRef, useState } from 'react';
import TEXTS from '../controller/TextVariables';
import Control from '../controller/Control';
import { renderToString } from 'react-dom/server';
import { DragZoom } from 'ol/interaction';
import { click as mapclick } from 'ol/events/condition';

const ZoomSelect = (props) => {
    const { map } = props;
    const { zoom_select } = TEXTS.controls;
    const className = 'zoom-select';

    const boxZoomInInteraction = new DragZoom({
        className: 'zoom-select',
        condition: (e) => {
            return mapclick;
        },
        out: false
    });
    boxZoomInInteraction.values_.id = 'zoom-select';

    const enableDragZoom = () => {
        map.addInteraction(boxZoomInInteraction);
        document.querySelector('#panel-map').classList.add('zoom-select');
    };

    const disableDragZoom = () => {
        map.removeInteraction(boxZoomInInteraction);
        document.querySelector('#panel-map').classList.remove('zoom-select');
    };

    const toggleEnabled = (e) => {
        const btnCtrl = document.querySelector(`.${className} button.${className}`);
        btnCtrl.classList.toggle('on');
        if (btnCtrl.classList.contains('on')) {
            enableDragZoom();
        } else {
            disableDragZoom();
        }
    };

    const controlAdded = (acontrol) => {
        const inp = acontrol.element.querySelector('button');
        if (inp) return;
        const inputSTR = renderToString(
            <button className={'nofocus ' + className} type="button" title={zoom_select.tooltip}>
                <span className={'icon-dragzoom'}></span>
            </button>
        );
        acontrol.element.innerHTML = inputSTR;
    };

    return (
        <Control map={map} className={'nofocus ' + className} clickHandler={toggleEnabled} onMount={controlAdded}>
            <button className={'nofocus ' + className} type="button" title={zoom_select.tooltip}>
                <span className={'icon-dragzoom'}></span>
            </button>
        </Control>
    );
};
export default ZoomSelect;
